import type { PayexThunkAction } from 'store/configureStore';

import { addOrderToUser } from 'actions/entities/orders/orders';
import { createPayment } from 'actions/entities/payments/payments';
import { enableSenderSMSNotification } from 'actions/entities/smsNotifications/smsNotifications';
import {
  CREATE_PAYMENT_FROM_ORDER_FAILURE,
  CREATE_PAYMENT_FROM_ORDER_REQUEST,
  CREATE_PAYMENT_FROM_ORDER_SUCCESS,
} from 'constants/index';
import {
  getPlatform,
  isLoggedIn,
  orderHasOwner,
  shouldReceiveSMSNotification,
  shouldReceiveWhatsappNotification,
} from 'selectors';

export const createPaymentFromOrder =
  (): PayexThunkAction<Promise<void>> => async (dispatch, getState) => {
    dispatch({ type: CREATE_PAYMENT_FROM_ORDER_REQUEST });

    try {
      const state = getState();
      const shouldAddOrderToUser = isLoggedIn(state) && !orderHasOwner(state);
      if (shouldAddOrderToUser) {
        await dispatch(addOrderToUser());
      }

      await dispatch(createPayment(getPlatform(state)));

      if (
        shouldReceiveSMSNotification(state) &&
        !shouldReceiveWhatsappNotification(state)
      ) {
        await dispatch(enableSenderSMSNotification());
      }

      dispatch({ type: CREATE_PAYMENT_FROM_ORDER_SUCCESS });
    } catch (_error) {
      dispatch({ type: CREATE_PAYMENT_FROM_ORDER_FAILURE });
    }
  };
